/*
  These helper function are used in
    - app/javascript/pages/customer_payment_methods.js
    - app/javascript/pages/patient_edit_form.js
  to update the UI, display errors, gather form input data,
  set common form styles and update button states.
*/

import log from '../logger';

export function notifyError(message) {
  const errorDiv = document.getElementById('form-errors');
  if (!errorDiv) return;

  const alertDiv = document.createElement('div');
  const joinedMessage = `There was an issue processing your payment Please <a href="/messages/new?category=support" class="alert-link" target="_blank">contact support</a> for assistance. ${message}`;
  alertDiv.classList.add('alert', 'alert-danger', 'alert-dismissable', 'fade', 'show');
  alertDiv.innerHTML = `${joinedMessage}<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>`;
  errorDiv.appendChild(alertDiv);
}

export function credentialsError(error) {
  log.error('A credentials error occurred', error);
}

export function stripeError(response) {
  log.error('A Stripe error occurred', response);
}

export function setSelectizeFieldsCSS() {
  // Set required field to -valid or -invalid as necessary
  // Set non-required field to -valid
  const requiredSelectize = document.querySelectorAll(
    '.selectize-control.single.customer-selectize .selectize-input.required'
  );
  const stateRequired = requiredSelectize[0];
  const phoneNumberTypeRequired = requiredSelectize[1];
  const stateFeedback = document.getElementById('state_invalid');
  const phoneNumberFeedback = document.getElementById('phone_type_invalid');
  const nonRequiredQuery = document.querySelectorAll('.selectize-control.single.customer-selectize .selectize-input');
  const notRequiredPhoneNumberType = nonRequiredQuery[1];

  if (stateRequired.childNodes[0]?.dataset?.value) {
    stateRequired.classList.remove('payment-form-invalid');
    stateFeedback.classList.remove('payment-form-invalid');
    stateRequired.classList.add('payment-form-valid');
  } else {
    stateRequired.classList.add('payment-form-invalid');
    stateFeedback.classList.add('payment-form-invalid');
  }

  if (phoneNumberTypeRequired && phoneNumberTypeRequired.childNodes[0]?.dataset?.value) {
    // Required in this context
    phoneNumberTypeRequired.classList.remove('payment-form-invalid');
    phoneNumberFeedback.classList.remove('payment-form-invalid');
    phoneNumberTypeRequired.classList.add('payment-form-valid');
  } else if (phoneNumberTypeRequired) {
    phoneNumberTypeRequired.classList.remove('payment-form-valid');
    phoneNumberTypeRequired.classList.add('payment-form-invalid');
    phoneNumberFeedback.classList.add('payment-form-invalid');
  } else if (notRequiredPhoneNumberType) {
    notRequiredPhoneNumberType.classList.remove('payment-form-invalid');
    phoneNumberFeedback.classList.remove('payment-form-invalid');
    notRequiredPhoneNumberType.classList.add('payment-form-valid');
  }
}

export function formFields() {
  const paymentMethodForm = document.getElementById('payment-method-form');
  const cardHolderInput = document.getElementById('card_holder_name');
  const addressInput = document.getElementById('address');
  const cityInput = document.getElementById('city');
  const stateInput = document.getElementById('state');
  const zipCodeInput = document.getElementById('zip_code');
  const emailInput = document.getElementById('email');
  const phoneInput = document.getElementById('telephone');
  const phoneNumberTypeInput = document.getElementById('phone_number_type');
  const cardNameInput = document.getElementById('card_name');
  const referralNameInput = document.getElementById('referral_name');
  const saveCardInput = document.getElementById('save_card');
  const orgIdInput = document.getElementById('orgId');
  let form;
  if (paymentMethodForm) {
    form = paymentMethodForm;
  } else {
    form = document.getElementById('payment-form');
  }

  const cardNameRow = document.getElementById('card_name_row');
  return {
    cardHolderInput,
    addressInput,
    cityInput,
    stateInput,
    zipCodeInput,
    emailInput,
    phoneInput,
    phoneNumberTypeInput,
    cardNameInput,
    saveCardInput,
    orgIdInput,
    form,
    cardNameRow,
    referralNameInput,
  };
}

export function formFieldData() {
  const {
    cardHolderInput,
    addressInput,
    cityInput,
    stateInput,
    zipCodeInput,
    emailInput,
    phoneInput,
    phoneNumberTypeInput,
    cardNameInput,
    saveCardInput,
    orgIdInput,
    referralNameInput,
  } = formFields();

  const cardHolderName = cardHolderInput?.value;
  const address = addressInput?.value;
  const cityName = cityInput?.value;
  const stateName = stateInput?.innerText;
  const stateId = stateInput?.value;
  const zipCode = zipCodeInput?.value;
  const email = emailInput?.value;
  const phone = phoneInput?.value;
  const phoneNumberTypeId = phoneNumberTypeInput?.value;
  const cardName = cardNameInput?.value;
  const referralName = referralNameInput?.value;
  const saveCard = saveCardInput?.checked;
  const orgId = orgIdInput.dataset?.org;
  return {
    cardHolderName,
    address,
    cityName,
    stateName,
    stateId,
    zipCode,
    email,
    phone,
    phoneNumberTypeId,
    cardName,
    saveCard,
    orgId,
    referralName,
  };
}

export function setInvalidFeedback(errors) {
  // { 'email.email': ['Message 1', 'Message 2'], }
  const { zipCodeInput, emailInput, phoneInput } = formFields();
  Object.entries(errors).forEach((error) => {
    const errorField = error[0];
    const errorMessages = error[1];
    if (errorField === 'email.email') {
      const emailInvalid = document.getElementById('email_invalid');
      emailInvalid.innerText = errorMessages.join('. ');
      emailInput.classList.add('is-invalid');
    }
    if (errorField.includes('phone_number.number')) {
      const phoneNumberInvalid = document.getElementById('telephone_invalid');
      phoneNumberInvalid.innerText = errorMessages.join('. ');
      phoneInput.classList.add('is-invalid');
    }
    if (errorField.includes('address.zip_code')) {
      const zipCodeInvalid = document.getElementById('zip_code_invalid');
      zipCodeInvalid.innerText = errorMessages.join('. ');
      zipCodeInput.classList.add('is-invalid');
    }
    if (errorField === 'email') {
      const emailInvalid = document.getElementById('email_invalid');
      emailInvalid.innerText = errorMessages.join('. ');
      emailInput.classList.add('is-invalid');
    }
  });
}

export function updateSubmitBtn({ disable, loading, defaultButtonText = null }) {
  const paymentMethodSubmit = document.getElementById('payment-method-submit');
  const submitPayment = document.getElementById('submit-payment');
  const cancelPayment = document.getElementById('cancel-payment');
  let submitButton;
  let innerTextLoading;
  if (submitPayment) {
    submitPayment.disabled = disable;
    cancelPayment.disabled = disable;
    submitButton = submitPayment;
    innerTextLoading = 'Processing payment...';
  } else if (paymentMethodSubmit) {
    paymentMethodSubmit.disabled = disable;
    submitButton = paymentMethodSubmit;
    innerTextLoading = 'Adding payment method...';
  }
  if (!submitButton) return;

  // Snapshot the button's original markup (e.g. a `bi-*` icon + label) once, before we first
  // mutate it, so a reset restores it verbatim instead of collapsing it to plain text.
  if (submitButton.dataset.originalContent === undefined) {
    submitButton.dataset.originalContent = submitButton.innerHTML;
  }

  if (loading) {
    submitButton.innerText = innerTextLoading;
    const loadingSpan = document.createElement('span');
    loadingSpan.classList.add('ml-2', 'spinner-border', 'spinner-border-sm');
    submitButton.appendChild(loadingSpan);
  } else {
    // An explicit label wins; otherwise restore the original markup (keeps the icon).
    submitButton.innerHTML = defaultButtonText ?? submitButton.dataset.originalContent;
  }
}

export function catchError(error) {
  log.error(error);
  const feedbackDiv = document.getElementById('promotion-feedback');
  if (feedbackDiv) {
    feedbackDiv.innerHTML = '';
  }
  notifyError(error.message);
  updateSubmitBtn({ disable: false, loading: false });
}

export function promotionCodeFeedback(message, styling) {
  const feedbackDiv = document.getElementById('promotion-feedback');
  feedbackDiv.innerHTML = '';
  const promoDiv = document.createElement('div');
  promoDiv.classList.add('alert', `alert-${styling}`, 'alert-dismissable', 'fade', 'show', 'row', 'd-flex');
  promoDiv.innerHTML = `<div class="col-11">${message}</div><button type="button" class="close col-1" data-dismiss="alert" aria-label="Close" id="reset-promotion-code"><span aria-hidden="true">&times;</span></button></div>`;
  feedbackDiv.appendChild(promoDiv);
}

export function stripeInputFieldStyles() {
  const style = {
    base: {
      fontFamily: 'Roboto, sans-serif',
      fontSmoothing: 'antialiased',
      color: '#384B6E', // $n600, Dark
      fontSize: '16px',
      '::placeholder': {
        color: '#929DB0', // Grey, matches browser placeholder color
      },
    },
    complete: {
      iconColor: '#60c496', // $green-light-400, Green
    },
    invalid: {
      fontFamily: 'Roboto, sans-serif',
      color: '#F25B64', // $red-300, Red
      iconColor: '#F25B64',
    },
  };
  const classes = {
    empty: 'form-control-invalid',
    invalid: 'form-control-invalid',
    complete: 'form-control-valid',
  };
  return {
    style,
    classes,
  };
}
